import React, { useState } from "react"
import PropTypes from "prop-types"
import { Box } from "datastory-shared/ui"
import { logEvent } from "datastory-shared/utils/analytics"

import GroupUI from "./GroupUI"
import Chart from "./Chart"

const HypoRiksdag = ({ data, ...props }) => {
  const [indicator, setIndicator] = useState(
    "og:og:ageInterval_og:date_og:politicalParty_[18,)"
  )

  const handleIndicatorChange = id => {
    setIndicator(id)

    if (id) logEvent("Interactives", `Changed indicator: ${id}`, "HypoRiksdag")
  }

  const { indicators, exampleIndicators, selectorPlacement, ...restProps } =
    props

  const indicatorMeta =
    Array.isArray(indicators) && indicators.find(i => i.value === indicator)

  return (
    <div>
      {selectorPlacement === "top" && Array.isArray(indicators) && (
        <div style={{ paddingBottom: "5rem", textAlign: "center" }}>
          <GroupUI
            onSetIndicator={handleIndicatorChange}
            indicator={indicator}
            indicators={indicators}
            exampleIndicators={exampleIndicators}
          />
        </div>
      )}

      {<Chart {...restProps} data={data[indicator]} />}

      {selectorPlacement === "bottom" && Array.isArray(indicators) && (
        <Box pt="1.5rem" textAlign="center">
          <GroupUI
            onSetIndicator={handleIndicatorChange}
            indicator={indicator}
            indicators={indicators}
            selectedItem={{ id: indicator, name: indicatorMeta?.name }}
            exampleIndicators={exampleIndicators}
          />
        </Box>
      )}
    </div>
  )
}

HypoRiksdag.propTypes = {
  indicators: PropTypes.array.isRequired,
  data: PropTypes.object.isRequired,
  exampleIndicators: PropTypes.array,
  selectorPlacement: PropTypes.string,
}

HypoRiksdag.defaultProps = {
  selectorPlacement: "top",
}

export default HypoRiksdag
